module.exports = __webpack_public_path__ + "img/0Q3A5468_L_Foamcore.c7e29661.jpg";